var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowTopRight = function SvgArrowTopRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8572 7.5672L18.8816 7.54284L18.8572 7.51847V5.14285H16.4816L16.4572 5.11847L16.4328 5.14285H8.57151V8.57142H13.0043L4.43286 17.1428L6.85723 19.5672L15.4287 10.9958V15.4286H18.8572V7.5672Z",
    fill: "currentColor"
  })));
};

export { SvgArrowTopRight as ReactComponent };
export default __webpack_public_path__ + "433d75d5a36d9acf638d5a91cb5d8426.svg";